
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * Deprecated_SocialTradingMasterUpdate struct
 */
class Deprecated_SocialTradingMasterUpdate {
  /**
   * Copy struct (shallow copy)
   * @this {!Deprecated_SocialTradingMasterUpdate}
   * @param {!Deprecated_SocialTradingMasterUpdate} other Other struct
   * @returns {!Deprecated_SocialTradingMasterUpdate} This struct
   */
  copy (other) {
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!Deprecated_SocialTradingMasterUpdate}
   * @returns {!Deprecated_SocialTradingMasterUpdate} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new Deprecated_SocialTradingMasterUpdateModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new Deprecated_SocialTradingMasterUpdateModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!Deprecated_SocialTradingMasterUpdate}
   * @param {!Deprecated_SocialTradingMasterUpdate} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof Deprecated_SocialTradingMasterUpdate)) {
      throw new TypeError('Instance of Deprecated_SocialTradingMasterUpdate is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!Deprecated_SocialTradingMasterUpdate}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return Deprecated_SocialTradingMasterUpdate.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!Deprecated_SocialTradingMasterUpdate} other Object value
   * @returns {!Deprecated_SocialTradingMasterUpdate} Created struct
   */
  static fromObject (other) {
    return new Deprecated_SocialTradingMasterUpdate().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!Deprecated_SocialTradingMasterUpdate}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return Deprecated_SocialTradingMasterUpdate.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!Deprecated_SocialTradingMasterUpdate}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 201
  }
}

export { Deprecated_SocialTradingMasterUpdate };

/**
 * Fast Binary Encoding Deprecated_SocialTradingMasterUpdate field model
 */
class FieldModelDeprecated_SocialTradingMasterUpdate extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4
  }

  /**
   * Get the field extra size
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelDeprecated_SocialTradingMasterUpdate.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 201
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @param {!Deprecated_SocialTradingMasterUpdate} fbeValue Default value, defaults is new Deprecated_SocialTradingMasterUpdate()
   * @returns {!Deprecated_SocialTradingMasterUpdate} Deprecated_SocialTradingMasterUpdate value
   */
  get (fbeValue = new Deprecated_SocialTradingMasterUpdate()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @param {!Deprecated_SocialTradingMasterUpdate} fbeValue Deprecated_SocialTradingMasterUpdate value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @param {!Deprecated_SocialTradingMasterUpdate} fbeValue Deprecated_SocialTradingMasterUpdate value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelDeprecated_SocialTradingMasterUpdate}
   * @param {Deprecated_SocialTradingMasterUpdate} fbeValue Deprecated_SocialTradingMasterUpdate value
   */
  setFields (fbeValue) {
  }
}

export { FieldModelDeprecated_SocialTradingMasterUpdate };

/**
 * Fast Binary Encoding Deprecated_SocialTradingMasterUpdate model
 */
class Deprecated_SocialTradingMasterUpdateModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelDeprecated_SocialTradingMasterUpdate(this.buffer, 4)
  }

  /**
   * Get the Deprecated_SocialTradingMasterUpdate model
   * @this {!Deprecated_SocialTradingMasterUpdateModel}
   * @returns {!FieldModelDeprecated_SocialTradingMasterUpdate} model Deprecated_SocialTradingMasterUpdate model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!Deprecated_SocialTradingMasterUpdateModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!Deprecated_SocialTradingMasterUpdateModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return Deprecated_SocialTradingMasterUpdateModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!Deprecated_SocialTradingMasterUpdateModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelDeprecated_SocialTradingMasterUpdate.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!Deprecated_SocialTradingMasterUpdateModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!Deprecated_SocialTradingMasterUpdateModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!Deprecated_SocialTradingMasterUpdateModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!Deprecated_SocialTradingMasterUpdateModel}
   * @param {!Deprecated_SocialTradingMasterUpdate} value Deprecated_SocialTradingMasterUpdate value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!Deprecated_SocialTradingMasterUpdateModel}
   * @param {!Deprecated_SocialTradingMasterUpdate} value Deprecated_SocialTradingMasterUpdate value, defaults is new Deprecated_SocialTradingMasterUpdate()
   * @return {!object} Deserialized Deprecated_SocialTradingMasterUpdate value and its size
   */
  deserialize (value = new Deprecated_SocialTradingMasterUpdate()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new Deprecated_SocialTradingMasterUpdate(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new Deprecated_SocialTradingMasterUpdate(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!Deprecated_SocialTradingMasterUpdateModel}
   * @param {!number} prev Previous Deprecated_SocialTradingMasterUpdate model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { Deprecated_SocialTradingMasterUpdateModel };
